import {
  useEffect, useMemo, useState,
} from 'react';

import { debounce, DebouncedFunc } from 'lodash';

// Debounce search string useState
const useSearchStr = (init?: string) => {
  const [searchStr, setSearchStr] = useState<string>(init || '');

  const handleChange = (newStr: string) => {
    setSearchStr(newStr);
  };

  const setSearchStrDebounced = useMemo(() => debounce(handleChange, 250), []);

  // Clean up on unmount
  useEffect(() => () => {
    setSearchStrDebounced.cancel();
  });

  return [searchStr, setSearchStrDebounced] as [
    string,
    DebouncedFunc<(e: any) => void>,
  ];
};

export default useSearchStr;
